<div fxLayoutAlign="space-between start">
    <div fxLayoutAlign="center center">
        <mat-icon *ngIf="data?.svgIcon" [svgIcon]="data?.svgIcon"></mat-icon>
        <span>{{data.message}}</span>
    </div>
    <mat-icon class="close-icon" [svgIcon]="'close'" (click)="closeSnackBar()"></mat-icon>
</div>
